import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-details-left-sidebar',
  templateUrl: './blog-details-left-sidebar.component.html',
  styleUrls: ['./blog-details-left-sidebar.component.css']
})
export class BlogDetailsLeftSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
